import React from 'react';

import type { GridRenderCellParams, GridRenderEditCellParams } from '@mui/x-data-grid-premium';

import type { TextFieldVariants } from '@mui/material/TextField';
import type { TypographyVariant } from '@mui/material/Typography';
import { useStyles } from 'tss-react/mui';

import QAmountField from 'components/QAmountField';
import type { QAmountProps } from 'components/QAmountField';

type QAmountFieldCellProps = Omit<QAmountProps, 'editable' | 'variant' | 'value'> & {
  params: GridRenderCellParams;
  value?: number | string;
  variant?: TypographyVariant;
};

export const QAmountFieldCell = (props: QAmountFieldCellProps) => {
  const { params, value: propsValue, wrapperStyles: otherWrapperStyles, ...other } = props;
  const { value: paramsValue } = params;

  let justifyContent = 'start';
  const align = props.align ?? params?.colDef?.align;
  if (align === 'center') {
    justifyContent = 'center';
  } else if (align === 'right') {
    justifyContent = 'end';
  }
  const wrapperStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent,
    height: '100%',
    ...otherWrapperStyles,
  };

  const value = propsValue ?? paramsValue ?? '';

  return (
    <QAmountField
      className='MuiDataGrid-cellContent'
      expectedSign='positive'
      fullWidth
      plain
      removeSpacing
      wrapperStyles={wrapperStyles}
      {...other}
      value={value}
    />
  );
};

type QAmountfieldEditCellProps = Omit<QAmountProps, 'editable' | 'variant' | 'value'> & {
  params: GridRenderEditCellParams;
  variant?: TextFieldVariants;
};

export const QAmountFieldEditCell = (props: QAmountfieldEditCellProps) => {
  const { params, ...other } = props;
  const { api, id, field, value } = params;
  const { css, cx } = useStyles();

  const handleValueChange = async ({ target: { value: newValue } }: any) => {
    api.setEditCellValue({
      id,
      field,
      value: newValue,
    });
  };

  return (
    <QAmountField
      autoFocus
      className={cx('MuiDataGrid-editInputCell MuiDataGrid-cell--textRight', css({ paddingTop: '2px' }))}
      classes={{ input: 'MuiDataGrid-cell--textRight' }}
      editable
      expectedSign='positive'
      fullWidth
      onChange={handleValueChange}
      onSubmit={handleValueChange}
      plain
      removeSpacing
      {...other}
      value={value}
    />
  );
};
